import { LABEL_STATUT_ECHEANCE } from '../../lib/format';

interface Props {
  statut: string;
}

const colorMap: Record<string, string> = {
  Payee: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  En_attente: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  En_retard: 'bg-red-500/15 text-red-300 border-red-500/30',
  Partielle: 'bg-blue-500/15 text-blue-300 border-blue-500/30',
};

export function StatutEcheanceBadge({ statut }: Props): JSX.Element {
  const color = colorMap[statut] ?? 'bg-slate-500/15 text-slate-300 border-slate-500/30';
  const label = LABEL_STATUT_ECHEANCE[statut] ?? statut;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md border ${color}`}
    >
      {label}
    </span>
  );
}
